import PropTypes from 'prop-types'

import styled from '@emotion/styled'
import { color, font, fontSize } from '@rushplay/theme'

import { noneOf } from './none-of'

/**
 * Render a Text component
 * @param {Object} props
 * @param {string} props.align Control CSS `text-align` value
 * @param {string} props.color Control CSS `color` value
 * @param {string} props.decoration Control CSS `text-decoration` value
 * @param {string} props.font Control CSS `font-family` value
 * @param {string} props.fontStyle Control CSS `font-style` value
 * @param {string} props.size Control CSS `font-size` value
 * @param {string} props.weight Control CSS `font-weight` value
 * @param {string} props.lineHeight Control CSS `line-height` value
 * @return {ReactComponent}
 * @example
 * <Text weight={600} color="white" align="center">
 *    Register
 * </Text>
 */

export const Text = styled('div', {
  shouldForwardProp: noneOf([
    'align',
    'as',
    'color',
    'decoration',
    'font',
    'fontStyle',
    'size',
    'weight',
    'lineHeight',
  ]),
})`
  ${props => props.align && `text-align: ${props.align}`};
  ${props => props.decoration && `text-decoration: ${props.decoration}`};
  ${props => props.fontStyle && `font-style: ${props.fontStyle}`};
  ${props => props.weight && `font-weight: ${props.weight}`};
  ${props => props.lineHeight && `line-height: ${props.lineHeight}em`};
  ${props => props.color && `color: ${color(props.color)(props)}`};
  ${props => props.size && `font-size: ${fontSize(props.size)(props)}`};
  ${props => props.font && `font-family: ${font(props.font)(props)}`};
`

Text.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  decoration: PropTypes.oneOf([
    'none',
    'underline',
    'overline',
    'line-through',
  ]),
  font: PropTypes.string,
  fontStyle: PropTypes.oneOf(['normal', 'italic']),
  lineHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  weight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}
